import { render, staticRenderFns } from "./PlaceAdd.vue?vue&type=template&id=04201428&scoped=true"
import script from "./PlaceAdd.vue?vue&type=script&lang=js"
export * from "./PlaceAdd.vue?vue&type=script&lang=js"
import style0 from "./PlaceAdd.vue?vue&type=style&index=0&id=04201428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04201428",
  null
  
)

export default component.exports